import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';

@Component({
  selector: 'app-notify-session-timeout',
  templateUrl: './notify-session-timeout.component.html',
  styleUrls: ['./notify-session-timeout.component.scss']
})
export class NotifySessionTimeoutComponent implements OnInit {

  time: number = 0;
  interval: any = null;
  constructor(
    public dialogRef: MatDialogRef<NotifySessionTimeoutComponent>,
    @Inject(MAT_DIALOG_DATA) public data: string,
    private authService: AuthenticationService,
    private router: Router,
  ) {
    // them chuc nang close message băng Esc vaf click chuot
    dialogRef.disableClose = true;
  }

  ngOnInit() {
  }

  reLogin() {
    this.dialogRef.close();
    if(this.data.includes('sign-anonymous')){
      this.authService.anonymousLogout();
    }else{
      this.authService.logout();
    }
    this.router.navigate([this.data]);
  }
}
